export type FontSource = 'google' | 'fontshare';

export interface FontDef {
  name: string;
  category: 'sans' | 'serif' | 'display' | 'handwriting';
  source: FontSource;
  weights: string[];
  downloadUrl: string;
}

// Mapeamento curado de fontes premium (FontShare + Google Fonts)
export const FONT_LIBRARY: Record<string, FontDef> = {
  // === FONTSHARE (Gratuitas para uso comercial) ===
  "Satoshi": {
    name: "Satoshi",
    category: "sans",
    source: "fontshare",
    weights: ["300", "400", "500", "700"],
    downloadUrl: "https://www.fontshare.com/fonts/satoshi"
  },
  "Clash Display": {
    name: "Clash Display",
    category: "display",
    source: "fontshare",
    weights: ["500", "700"],
    downloadUrl: "https://www.fontshare.com/fonts/clash-display"
  },
  "Cabinet Grotesk": {
    name: "Cabinet Grotesk",
    category: "sans",
    source: "fontshare",
    weights: ["400", "500", "700"],
    downloadUrl: "https://www.fontshare.com/fonts/cabinet-grotesk"
  },
  "Pally": {
    name: "Pally",
    category: "display",
    source: "fontshare",
    weights: ["400", "700"],
    downloadUrl: "https://www.fontshare.com/fonts/pally"
  },
  "Gambetta": {
    name: "Gambetta",
    category: "serif",
    source: "fontshare",
    weights: ["400", "700"],
    downloadUrl: "https://www.fontshare.com/fonts/gambetta"
  },
  "Switzer": {
    name: "Switzer",
    category: "sans",
    source: "fontshare",
    weights: ["400", "500", "700"],
    downloadUrl: "https://www.fontshare.com/fonts/switzer"
  },
  "General Sans": {
    name: "General Sans",
    category: "sans",
    source: "fontshare",
    weights: ["400", "500", "700"],
    downloadUrl: "https://www.fontshare.com/fonts/general-sans"
  },
  "Epilogue": {
    name: "Epilogue",
    category: "sans",
    source: "fontshare",
    weights: ["400", "500", "700"],
    downloadUrl: "https://www.fontshare.com/fonts/epilogue"
  },
  
  // === GOOGLE FONTS (Para combinações híbridas) ===
  "Montserrat": {
    name: "Montserrat",
    category: "sans",
    source: "google",
    weights: ["400", "500", "700"],
    downloadUrl: "https://fonts.google.com/specimen/Montserrat"
  },
  "Playfair Display": {
    name: "Playfair Display",
    category: "serif",
    source: "google",
    weights: ["400", "500", "700"],
    downloadUrl: "https://fonts.google.com/specimen/Playfair+Display"
  },
  "Space Grotesk": {
    name: "Space Grotesk",
    category: "sans",
    source: "google",
    weights: ["400", "500", "700"],
    downloadUrl: "https://fonts.google.com/specimen/Space+Grotesk"
  },
  "Lato": {
    name: "Lato",
    category: "sans",
    source: "google",
    weights: ["400", "700"],
    downloadUrl: "https://fonts.google.com/specimen/Lato"
  },
  "Inter": {
    name: "Inter",
    category: "sans",
    source: "google",
    weights: ["400", "500", "700"],
    downloadUrl: "https://fonts.google.com/specimen/Inter"
  },
  "Josefin Slab": {
    name: "Josefin Slab",
    category: "serif",
    source: "google",
    weights: ["400", "600", "700"],
    downloadUrl: "https://fonts.google.com/specimen/Josefin+Slab"
  },
  "Abril Fatface": {
    name: "Abril Fatface",
    category: "display",
    source: "google",
    weights: ["400"],
    downloadUrl: "https://fonts.google.com/specimen/Abril+Fatface"
  },
  "Fredoka": {
    name: "Fredoka",
    category: "display",
    source: "google",
    weights: ["400", "500", "700"],
    downloadUrl: "https://fonts.google.com/specimen/Fredoka"
  },
  "Cormorant Garamond": {
    name: "Cormorant Garamond",
    category: "serif",
    source: "google",
    weights: ["400", "500", "700"],
    downloadUrl: "https://fonts.google.com/specimen/Cormorant+Garamond"
  },
  "Oswald": {
    name: "Oswald",
    category: "sans",
    source: "google",
    weights: ["400", "500", "700"],
    downloadUrl: "https://fonts.google.com/specimen/Oswald"
  },
};

// Helper: Gerar URL de carregamento dinâmico
export const getFontCssUrl = (fontName: string): string => {
  const font = FONT_LIBRARY[fontName];
  if (!font) return "";
  
  if (font.source === "fontshare") {
    const kebabName = fontName.toLowerCase().replace(/\s+/g, '-');
    const weights = font.weights.join(',');
    return `https://api.fontshare.com/v2/css?f[]=${kebabName}@${weights}&display=swap`;
  } else {
    const encodedName = fontName.replace(/\s+/g, '+');
    const weights = font.weights.join(';');
    return `https://fonts.googleapis.com/css2?family=${encodedName}:wght@${weights}&display=swap`;
  }
};

// Helper: Obter link de download para o usuário
export const getFontDownloadLink = (fontName: string): string => {
  return FONT_LIBRARY[fontName]?.downloadUrl || `https://fonts.google.com/specimen/${fontName.replace(/\s+/g, '+')}`;
};
